<template>
  <table class="subOpt__content">
    <client-only>
      <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="false"></loading>
    </client-only>
    <tbody>
      <tr class="subOpt__offer">
        <td class="subOpt__field subOpt__name">
          <span class="subscription__name">{{ getOfferSubName(offer.subName) }}</span>
          <span v-if="offer.subRenewalInfo" ref="subscriptionRenewal" class="subscription__renewal" @click.stop="toggleSubscriptionRenewalDDInfo">
            <span>{{ offer.subRenewalInfo }}</span
            ><br />
            <span class="subscription__renewal-cancel"
              >Cancel Anytime <font-awesome-icon ref="infoIcon" :icon="['fas', 'info-circle']" class="fa fa-w-24 subscription__renewal-icon"
            /></span>
            <!-- eslint-disable vue/no-v-html -->
            <span
              v-if="subscriptionRenewalDDInfoVisible"
              class="subscription__renewal-tooltip"
              role="tooltip"
              :style="{ '--arrow-left': arrowOffset }"
              v-html="subRenewalTooltipInfo"
            ></span>
            <!-- eslint-enable vue/no-v-html -->
          </span>
          <span v-if="offer.subType" class="subscription__type">{{ offer.subType }}</span>
        </td>
      </tr>
      <tr class="subOpt__offer">
        <td>
          <table class="subOpt__tbl">
            <tbody>
              <tr>
                <td class="subOpt__field" :class="hasSaving ? 'subOpt__tblField--25' : 'subOpt__tblField--33'">
                  <span class="subOpt__header">Issues</span>
                  {{ offer.numOfIssues }}
                </td>
                <td class="subOpt__field" :class="hasSaving ? 'subOpt__tblField--25' : 'subOpt__tblField--33 subOpt__field--pl8'">
                  <span class="subOpt__header">RRP</span>
                  <span
                    class="subOpt__rrp"
                    :class="{
                      'text-decoration--none': parseInt(offer.rrp - offer.price) === 0,
                      'text-decoration--line-through': parseInt(offer.rrp - offer.price) > 0
                    }"
                    >{{ formatCurrency(offer.rrp) }}</span
                  >
                </td>
                <td v-if="hasSaving" class="subOpt__field subOpt__tblField--25">
                  <span class="subOpt__header">Saving</span>
                  <span>{{ formatCurrency(offer.rrp - offer.price) }}</span>
                </td>
                <td class="subOpt__field" :class="hasSaving ? 'subOpt__tblField--25' : 'subOpt__tblField--33 subOpt__field--center'">
                  <PaymentImages :is-mobile="true" :offer-payment-type="offer.paymentType" :is-giftcard="offer.sku === 'gift-card' || offer.sku === 'e-giftcards'" />
                </td>
              </tr>
            </tbody>
          </table>
        </td>
        <td></td>
      </tr>
      <tr v-if="offer.freeGiftEnabled" class="subOpt__freeGift">
        <td v-if="offer.freeGiftEnabled">
          <span><strong>Free Gift Details</strong> </span>
          <br />
          <span class="green-text">{{ offer.freeGiftDescription }}</span>
        </td>
      </tr>
      <tr class="subOpt__offer">
        <td :class="{ 'subOpt__field--25': offer.freeGiftEnabled, 'subOpt__field--50': !offer.freeGiftEnabled }" class="subOpt__field">
          <span class="subOpt__header">Our Price</span>
          <span class="subOpt__price">{{ formatCurrency(offer.price) }}</span>
        </td>

        <td v-if="offer.freeGiftEnabled" class="subOpt__field subOpt__field--25">
          <div class="freegift-overlay">
            <span class="freegift-overlay__txt1">FREE</span>
            <span class="freegift-overlay__txt2">GIFT</span>
          </div>
        </td>

        <td class="subOpt__field subOpt__field--50">
          <div v-if="isSingleIssuesOffer && offer.available === false && offer.qty === 0" class="add-to-basket-pdp subOpt__button add-to-basket-pdp--disabled" title="Out of Stock">
            OUT OF STOCK
          </div>
          <div v-else-if="magazine.enabled" class="add-to-basket-pdp subOpt__button" title="add to basket" @click.prevent="handleClickAction(offer, 'add')">BUY</div>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import { formatCurrency } from '~/lib/util/basket'
import basketMixin from '~/mixins/basket.vue'
import gtmProductPageMixin from '@/mixins/gtm/product-page'

export default {
  name: 'MobileOffer',
  components: {
    PaymentImages: () => import('~/components/common/product/PaymentImages.vue')
  },
  mixins: [gtmProductPageMixin, basketMixin],
  props: {
    offer: {
      type: Object,
      required: true,
      default() {
        return {}
      }
    },
    magazine: {
      type: Object,
      required: true,
      default() {
        return {}
      }
    },
    isDefault: {
      type: String,
      required: false,
      default() {
        return '0'
      }
    },
    styledClass: {
      type: String,
      required: false,
      default() {
        return 'pdp'
      }
    },
    isSingleIssuesOffer: {
      type: Boolean,
      required: true,
      default() {
        return false
      }
    }
  },
  data() {
    return {
      isLoading: false,
      subscriptionRenewalDDInfoVisible: false,
      subRenewalTooltipInfo: `You can choose to cancel your subscription at any time, including during a trial if one applies, and no further payments will be taken.<br/><br/>Your first Direct Debit payment for the initial price will be collected by ${this.magazine.publisher} shortly after placing your order. Your subscription will then automatically renew by Direct Debit at the frequency shown.`,
      arrowOffset: '0px'
    }
  },
  computed: {
    hasSaving() {
      return parseInt(this.offer.rrp - this.offer.price) > 0
    }
  },
  created() {
    this.$root.$on('desktop-offer-renewal-tooltip-opened', this.handleOtherTooltipOpened)
  },
  mounted() {
    document.addEventListener('click', this.handleDocumentClick)
    this.$nextTick(() => {
      this.calculateArrowPosition()
    })
    window.addEventListener('resize', this.calculateArrowPosition)
  },
  beforeDestroy() {
    this.$root.$off('desktop-offer-renewal-tooltip-opened', this.handleOtherTooltipOpened)
    document.removeEventListener('click', this.handleDocumentClick)
    window.removeEventListener('resize', this.calculateArrowPosition)
  },
  methods: {
    calculateArrowPosition() {
      try {
        if (!this.$refs.subscriptionRenewal) return

        const renewal = this.$refs.subscriptionRenewal
        const icon = renewal.querySelector('.subscription__renewal-icon')

        if (!icon) return

        const iconRect = icon.getBoundingClientRect()
        const renewalRect = renewal.getBoundingClientRect()
        const offset = iconRect.left - renewalRect.left + iconRect.width / 2
        this.arrowOffset = `calc(${offset}px - 5px)`
      } catch (error) {
        console.error('Error calculating arrow position:', error)
      }
    },
    toggleSubscriptionRenewalDDInfo() {
      const willOpen = !this.subscriptionRenewalDDInfoVisible
      this.subscriptionRenewalDDInfoVisible = willOpen

      if (willOpen) {
        this.$root.$emit('desktop-offer-renewal-tooltip-opened', this._uid)
      }
    },
    handleOtherTooltipOpened(openedByUid) {
      if (openedByUid !== this._uid) {
        this.subscriptionRenewalDDInfoVisible = false
      }
    },
    handleDocumentClick(event) {
      const renewalElement = this.$refs.subscriptionRenewal

      if (!renewalElement || renewalElement.contains(event.target)) {
        return
      }

      this.subscriptionRenewalDDInfoVisible = false
    },
    formatCurrency(value) {
      return formatCurrency(value)
    },
    async handleClickAction(offer, action) {
      console.log('MobileOffer handleClickAction offer=', offer)
      console.log('MobileOffer handleClickAction action=', action)

      const item = {
        title: this.magazine.title,
        imageUrl: offer.imageUrl,
        productId: this.magazine.productId,
        id: this.magazine.id,
        sku: this.magazine.sku,
        offer,
        category: this.magazine.category,
        subCategory: this.magazine.subCategory
      }

      // Update the BE Basket data
      const ret = await this.updateBasket({ item, action, source: 'PRODUCT', sourceVersion: this.$config.ProductPageVersion })

      // GTM & FB push events integration
      !ret?.error && this.pushGTMAndFBAfterButtonClick({ action, item })

      // Show the basket overlay
      !ret?.error && this.$nuxt.$emit('SHOW_BASKET', true)
    },
    getOfferSubName(value) {
      if (!value) {
        return ''
      }

      return value.replace(/\s*\((Print & Digital|Digital Edition|Print Edition|Membership)\)\s*$/i, '').trim()
    }
  }
}
</script>

<style lang="scss">
@media (max-width: $screen-xs-max) {
  .add-to-basket-pdp--disabled {
    font-size: 16px !important;
    background-color: gray !important;
  }
  .subOpt {
    &__content {
      position: relative;
      padding: 5px 10px;
      width: 100%;
    }
    &__field {
      display: inline-block;
      padding: 10px 8px;
      text-align: left;
      text-align: left;
      font-size: 12px;
    }
    &__name {
      display: flex;
      flex-flow: column;
      width: 100%;
      font-size: 18px;
      font-weight: 700;
      height: auto;
    }
    &__tbl {
      border: 1px solid #bcbcbc;
      border-radius: 5px;
      width: 95%;
      margin: 0 auto;
    }
    &__header {
      display: block;
      width: 100%;
      font-weight: 700;
      color: #666;
    }
    &__payment {
      max-width: 70px;
      vertical-align: middle;
    }
    &__price {
      color: #e20c0b;
      font-weight: 700;
      font-size: 16px;
    }
    &__tblField--25 {
      width: 25%;
      // img {
      //   min-height: 44px;
      // }
    }
    &__tblField--33 {
      width: 33.33%;
    }
    &__field--center {
      text-align: center;
    }
    &__field--pl8 {
      padding-left: 8%;
    }
    &__field--50 {
      width: 50%;
    }
    &__field--25 {
      width: 25%;
    }
    &__button {
      max-width: 200px !important;
    }
    &__freeGift {
      display: inline-block;
      padding: 10px 8px;
      text-align: left;
      text-align: left;
      font-size: 14px;
    }
    &__freeGiftImg {
      float: right;
    }
  }
}

.subscription {
  &__name {
    font-size: 18px;
    font-weight: 700;
    color: #242424;
  }
  &__renewal {
    position: relative;
    display: inline-block;
    font-size: 12px;
    font-weight: 400;
    color: #353535;
    cursor: pointer;
  }
  &__renewal-tooltip {
    position: absolute;
    top: calc(100% + 6px);
    left: 0;
    z-index: 10;
    width: 300px;
    max-width: 90%;
    padding: 15px;
    border-radius: 4px;
    font-size: 11px;
    line-height: 1.3;
    color: #fff;
    background-color: #666666;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
    white-space: normal;
  }
  &__renewal-tooltip::before {
    content: '';
    position: absolute;
    top: -5px;
    left: var(--arrow-left, 0);
    width: 0;
    height: 0;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-bottom: 5px solid #666666;
  }
  &__renewal-icon {
    background-color: #fff;
    color: #a1a1a1;
    border-radius: 50%;
  }
  &__type {
    font-size: 12px;
    font-weight: 400;
    color: #353535;
  }
}
.saving {
  &__first-line {
    font-size: 12px;
    color: #353535;
    font-weight: 700;
  }
  &__second-line {
    font-weight: 400;
    font-size: 12px;
    color: #666666;
  }
}

.subOpt__field--25 {
  .freegift-overlay {
    float: right;
    position: relative;
    min-width: 36px;
    max-width: 36px;
    min-height: 36px;
    max-height: 36px;
    z-index: 0;
    background-color: #df0000;
    border-radius: 30px;
    border: 2px #fff solid;
    text-align: center;
    line-height: 13px;
    left: 5px;
  }
  .freegift-overlay__txt1 {
    position: absolute;
    color: #fff;
    font-weight: 700;
    width: 36px;
    right: -2px;
    top: 6px;
    font-size: 10px;
    text-align: center;
  }

  .freegift-overlay__txt2 {
    position: absolute;
    color: #fff;
    font-weight: 700;
    width: 36px;
    right: -2px;
    top: 16px;
    font-size: 10px;
    text-align: center;
  }
}
</style>
